import { ShippingZone } from "@core/types";

export const getMainShippingZone = (shippingZones: ShippingZone[]) => {
  const mainShippingZone = shippingZones.find((shippingZone) => shippingZone.name.includes("Грозный"));
  return mainShippingZone ?? shippingZones[0];
};
